import React from 'react'
import { CircularProgress } from '@mui/material'

const Loader = ({ type = "full" }) => {
  return (
    <div className={type === "full" ? "loder" : ""} >
      <div className="loader-box" style={{ color: "#6261CC", display: "flex", justifyContent: 'center', alignItems: "center" }}>
        <CircularProgress size={24} thickness={5} sx={{ color: "#6261CC", marginRight: 1 }} />
        <span style={{ color: "#6261CC", marginLeft: 8, fontWeight: 500 }}>Loading...</span>
      </div>
    </div >
  )
}

export default Loader
